import BaseService from "../baseService";
class Senhas extends BaseService {
    constructor(id) {
        const resource = "portal-acesso-papeis";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new Senhas(id);
